var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1755_1320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10V11.6667C13.3333 12.5858 12.5858 13.3333 11.6667 13.3333H8.33333C7.41417 13.3333 6.66667 12.5858 6.66667 11.6667V10H0V17.5C0 18.8783 1.12167 20 2.5 20H17.5C18.8783 20 20 18.8783 20 17.5V10H13.3333ZM18.3333 17.5C18.3333 17.96 17.96 18.3333 17.5 18.3333H2.5C2.04 18.3333 1.66667 17.96 1.66667 17.5V11.6667H5C5 13.505 6.495 15 8.33333 15H11.6667C13.505 15 15 13.505 15 11.6667H18.3333V17.5ZM8.82167 8.67833L6.0775 5.93417L7.25583 4.75583L9.16667 6.66667V0H10.8333V6.66667L12.7442 4.75583L13.9225 5.93417L11.1783 8.67833C10.8533 9.00333 10.4267 9.16583 10 9.16583C9.57333 9.16583 9.14667 9.00333 8.82167 8.67833Z",
    fill: "#2D4343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1755_1320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.4c96acab656421c694d657fcaf622b23.svg";
export { ForwardRef as ReactComponent };